import {
  getPrice,
  checkDisplayedPrices,
  getNextScreenLimit,
  getScreenPriceOptions,
  getScreenOptionFromPlanId,
  getPlanId,
  updateStripeSource,
  deleteStripeSource,
  unpauseSubscription,
  pauseSubscription,
  activateCancellationOffer,
  renewSubscription,
  fetchSubscriptionData,
  createSubscription,
  cancelSubscription,
  tempValidatePromoCode
} from '@/services/subscriptions';

export default {
  methods: {
    cancelSubscription,
    createSubscription,
    deleteStripeSource,
    fetchSubscriptionData,
    getScreenOptionFromPlanId,
    getPlanId,
    getPrice,
    checkDisplayedPrices,
    getNextScreenLimit,
    getScreenPriceOptions,
    pauseSubscription,
    activateCancellationOffer,
    renewSubscription,
    tempValidatePromoCode,
    unpauseSubscription,
    updateStripeSource
  }
};
